import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./PostDetalle.css";

function PostDetalle() {
  const { slug } = useParams();

  const [post, setPost] = useState(null);
  const [comentarios, setComentarios] = useState([]);
  const [nuevoComentario, setNuevoComentario] = useState("");

  const usuarioGuardado = JSON.parse(localStorage.getItem("usuario"));
  const esModerador =
    usuarioGuardado?.rol?.toLowerCase() === "MODERADOR";

  useEffect(() => {
    fetch(`http://localhost:8080/api/posts/slug/${slug}`)
      .then((res) => res.json())
      .then((data) => setPost(data))
      .catch((error) => console.error("Error cargando post:", error));
  }, [slug]);

  useEffect(() => {
    if (!post?.id) return;

    fetch(`http://localhost:8080/api/posts/${post.id}/comentarios`)
      .then((res) => res.json())
      .then((data) => setComentarios(data))
      .catch((error) => console.error("Error cargando comentarios:", error));
  }, [post]);

  const enviarComentario = async (e) => {
    e.preventDefault();

    if (!nuevoComentario.trim()) return;

    const usuarioGuardado = JSON.parse(localStorage.getItem("usuario"));
    const usuarioId = usuarioGuardado?.id;

    if (!usuarioId) {
      alert("Debes iniciar sesión para comentar");
      return;
    }

    try {
      const response = await fetch(
        `http://localhost:8080/api/posts/${post.id}/comentarios`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            usuarioId: usuarioId,
            contenido: nuevoComentario,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("No se pudo guardar el comentario");
      }

      const comentarioGuardado = await response.json();

      setComentarios([comentarioGuardado, ...comentarios]);
      setNuevoComentario("");
    } catch (error) {
      console.error(error);
      alert("No se pudo guardar el comentario");
    }
  };

  const eliminarComentario = async (comentarioId) => {
    const confirmar = window.confirm(
      "¿Seguro que deseas eliminar este comentario?"
    );

    if (!confirmar) return;

    try {
      const response = await fetch(
        `/api/posts/${post.id}/comentarios/${comentarioId}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("No se pudo eliminar el comentario");
      }

      setComentarios(
        comentarios.filter((comentario) => comentario.id !== comentarioId)
      );
    } catch (error) {
      console.error(error);
      alert("No se pudo eliminar el comentario");
    }
  };

  if (!post) return <p className="post-loading">Cargando post...</p>;

  return (
    <main className="post-page">
      <div className="post-breadcrumb">
        <Link to="/">Club Oficial RP</Link>
        <span>/</span>
        <Link to="/noticias">Noticias</Link>
      </div>

      <article className="post-card">
        <section className="post-main">
          <h1>{post.titulo}</h1>

          <div className="post-meta">
            <span>Por {post.autor || "Administrador"}</span>
            <span>•</span>
            <span>
              {new Date(post.creadoEn).toLocaleDateString("es-PE")}
            </span>
          </div>

          <img
            className="post-cover"
            src={post.imagenPortada}
            alt={post.titulo}
          />

          <p className="post-resumen">{post.resumen}</p>

          <div className="post-content">{post.contenido}</div>
        </section>
      </article>

      <section className="comentarios-card">
        <h2>Comentarios</h2>

        <form className="comentario-form" onSubmit={enviarComentario}>
          <textarea
            rows="4"
            placeholder="Escribe tu comentario..."
            value={nuevoComentario}
            onChange={(e) => setNuevoComentario(e.target.value)}
          />

          <button type="submit">
            Publicar comentario
          </button>
        </form>

        <div className="comentarios-lista">
          {comentarios.length === 0 ? (
            <p className="sin-comentarios">
              Sé el primero en comentar.
            </p>
          ) : (
            comentarios.map((comentario) => (
              <div className="comentario-item" key={comentario.id}>
                <div className="comentario-header">
                  <div>
                    <strong>{comentario.autor} </strong>
                    <span>
                      {new Date(comentario.creadoEn).toLocaleDateString("es-PE")}
                    </span>
                  </div>

                  {esModerador && (
                    <button
                      className="comentario-eliminar-btn"
                      onClick={() => eliminarComentario(comentario.id)}
                    >
                      Eliminar
                    </button>
                  )}
                </div>

                <p>{comentario.contenido}</p>
              </div>
            ))
          )}
        </div>
      </section>
    </main>
  );
}

export default PostDetalle;